import { render, staticRenderFns } from "./VenueMenu.vue?vue&type=template&id=edf65dce&"
import script from "./VenueMenu.vue?vue&type=script&lang=js&"
export * from "./VenueMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports